import React from 'react';
import { useEvent } from '../events/event/EventProvider';
import IdentityCard from '../identityCard/IdentityCard';
import BadgeCard from '../badgeCard/BadgeCard';
import './Home.scss';
import bridge_badge from '../bridge_badge.png';
import stake_badge from '../stake_badge.png';
import { ReactComponent as MercleLogo } from './mercle.svg';
// import BlurImg1 from '../commid_blur.png';
// import BlurImg2 from '../contrid_blur.png';

const Home = () => {
  const [{ event, nftProfile, campaign }] = useEvent();
  return (
    <>
      <div className='center-text'>
        <div className='text'>
          <p className='profile'>
            Wall Of <span> identity</span>
          </p>
          <p className='sub-text'>powered by <MercleLogo className='pointer' /></p>
        </div>
        <div className='description'>
          WELCOME TO YOUR XION GLOBAL IDENTITY.
          <br />
          A PLACE TO CAPTURE MORE OF WHAT YOU DO ON XION.
        
        </div>
        <div className='dynamic_text'>
          <div className='white_line'></div>
          <p>dynamic identities</p>
          <div className='white_line'></div>
        </div>
        <div className='identity_cards'>
          <IdentityCard title='PROMETHEAN SAGA' event={event} nftProfile={nftProfile} campaign={campaign}  img = ''/>
          {/* <IdentityCard title='COMMUNITY ID' event={event} nftProfile={nftProfile} campaign={campaign}  img ={BlurImg1}/> */}
          {/* <IdentityCard title='CONTRIBUTOR ID' event={event} nftProfile={nftProfile} campaign={campaign} img = {BlurImg2} /> */}
        </div>

        <div className='dynamic_text'>
          <div className='white_line'></div>
          <p>Badges</p>
          <div className='white_line'></div>
        </div>

        <div className='badges'>
          <BadgeCard title='STAKOOOR BADGES' desc = ' Help secure the network, and earn staking rewards as a result.' img= {stake_badge}/>
          <BadgeCard title='BRIDGOOOR BADGES' desc = 'Bridge in funds to utilize throughout the ecosystem' img = {bridge_badge}/>
          {/* <BadgeCard title='BELIEVOOOR BADGES'/> */}
          </div>
      </div>
    </>
  );
};

export default Home;
